// ** Router imports
import { useRoutes } from "react-router-dom";
// ** React Imports
import { useMemo } from "react";

// ** GetRoutes
import { getRoutes } from "./routes";

// ** Hooks Imports
import { useLayout } from "@hooks/useLayout";

const Router = () => {
  // ** Hooks
  const { layout } = useLayout();
  
  const allRoutes = useMemo(() => getRoutes(layout), [layout]);

  const routes = useRoutes([...allRoutes]);

  return routes;
};

export default Router;